import { BaseAPI } from "./base";
import type { ApiResponse, GlobalSettings } from "~/types/ui";

export class SettingsApi extends BaseAPI {
  async getGlobal(): Promise<ApiResponse<GlobalSettings>> {
    return this.get<GlobalSettings>(`settings/global`);
  }

  async getGlobalAll(): Promise<ApiResponse<GlobalSettings>> {
    return this.get<GlobalSettings>(`settings/global/all`);
  }

  async setGlobal(payload: GlobalSettings): Promise<ApiResponse<void>> {
    return this.post<void>(`settings/global`, payload);
  }

  async uploadGlobalWhiteLabelImage(file: File): Promise<ApiResponse<void>> {
    const formData = new FormData();
    formData.append("image", file);
    return this.post<void>(`settings/global-white-label`, formData);
  }

  async deleteGlobalWhiteLabelImage(): Promise<ApiResponse<void>> {
    return this.delete(`settings/global-white-label`);
  }
}
